
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/changelog/[version]",
      function () {
        return require("private-next-pages/changelog/[version].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/changelog/[version]"])
      });
    }
  